/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListGetUserCouponAvailablePageRespVo,
  ResponseListGetUserCouponOptionRespVo,
  ResponseListGetUserCouponPayAvailableRespVo,
  ResponseLong,
  ResponsePageDataGetUserCouponAvailablePageRespVo,
  ResponsePageDataGetUserCouponUsedPageListRespVo,
  ResponsePageDataUserCouponHistoryRespVo,
  ResponsePageDataUserCouponInfoRespVo,
  ResponseUserCouponInfoRespVo,
  UserCouponCreateReqVo,
  UserCouponHistoryCreateReqVo,
  UserCouponHistoryUpdateReqVo,
  UserCouponUpdateReqVo,
} from '../models/index';
import {
    ResponseListGetUserCouponAvailablePageRespVoFromJSON,
    ResponseListGetUserCouponAvailablePageRespVoToJSON,
    ResponseListGetUserCouponOptionRespVoFromJSON,
    ResponseListGetUserCouponOptionRespVoToJSON,
    ResponseListGetUserCouponPayAvailableRespVoFromJSON,
    ResponseListGetUserCouponPayAvailableRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataGetUserCouponAvailablePageRespVoFromJSON,
    ResponsePageDataGetUserCouponAvailablePageRespVoToJSON,
    ResponsePageDataGetUserCouponUsedPageListRespVoFromJSON,
    ResponsePageDataGetUserCouponUsedPageListRespVoToJSON,
    ResponsePageDataUserCouponHistoryRespVoFromJSON,
    ResponsePageDataUserCouponHistoryRespVoToJSON,
    ResponsePageDataUserCouponInfoRespVoFromJSON,
    ResponsePageDataUserCouponInfoRespVoToJSON,
    ResponseUserCouponInfoRespVoFromJSON,
    ResponseUserCouponInfoRespVoToJSON,
    UserCouponCreateReqVoFromJSON,
    UserCouponCreateReqVoToJSON,
    UserCouponHistoryCreateReqVoFromJSON,
    UserCouponHistoryCreateReqVoToJSON,
    UserCouponHistoryUpdateReqVoFromJSON,
    UserCouponHistoryUpdateReqVoToJSON,
    UserCouponUpdateReqVoFromJSON,
    UserCouponUpdateReqVoToJSON,
} from '../models/index';

export interface UserCouponsEnableIdHandlePutRequest {
    id: number;
    handle: number;
}

export interface UserCouponsHistoryIdDeleteRequest {
    id: number;
}

export interface UserCouponsHistoryIdPutRequest {
    id: number;
    userCouponHistoryUpdateReqVo?: UserCouponHistoryUpdateReqVo;
}

export interface UserCouponsHistoryListGetRequest {
    currentPage: number;
    pageSize: number;
    userId?: number;
    userCouponId?: number;
    intOutType?: number;
    enable?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserCouponsHistoryPostRequest {
    userCouponHistoryCreateReqVo?: UserCouponHistoryCreateReqVo;
}

export interface UserCouponsIdDeleteRequest {
    id: number;
}

export interface UserCouponsIdGetRequest {
    id: number;
}

export interface UserCouponsIdPutRequest {
    id: number;
    userCouponUpdateReqVo?: UserCouponUpdateReqVo;
}

export interface UserCouponsListAvailableGetRequest {
    currentPage: number;
    pageSize: number;
    grantType?: number;
    additionalServiceIds?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserCouponsListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    currencyCode?: string;
    source?: number;
    canTrans?: number;
    enable?: number;
    startTime?: string;
    endTime?: string;
    userName?: string;
    userCode?: string;
    status?: number;
    grantType?: number;
    additionalServiceIds?: number;
}

export interface UserCouponsListPayAvailableGetRequest {
    billId: number;
}

export interface UserCouponsListUsedGetRequest {
    currentPage: number;
    pageSize: number;
    grantType?: number;
    additionalServiceIds?: number;
    startTime?: string;
    endTime?: string;
}

export interface UserCouponsPostRequest {
    userCouponCreateReqVo?: UserCouponCreateReqVo;
}

/**
 * 
 */
export class UserCouponControllerApi extends runtime.BaseAPI {

    /**
     * 指定用户有优惠卷数据编号, 进行可用|不可用操作 指定用户有优惠卷数据编号, 进行可用|不可用操作
     * 指定用户有优惠卷数据编号, 进行可用|不可用操作
     */
    async userCouponsEnableIdHandlePutRaw(requestParameters: UserCouponsEnableIdHandlePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsEnableIdHandlePut().'
            );
        }

        if (requestParameters['handle'] == null) {
            throw new runtime.RequiredError(
                'handle',
                'Required parameter "handle" was null or undefined when calling userCouponsEnableIdHandlePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/enable/{id}/{handle}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters['handle']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定用户有优惠卷数据编号, 进行可用|不可用操作 指定用户有优惠卷数据编号, 进行可用|不可用操作
     * 指定用户有优惠卷数据编号, 进行可用|不可用操作
     */
    async userCouponsEnableIdHandlePut(requestParameters: UserCouponsEnableIdHandlePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsEnableIdHandlePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 优惠卷管理-发行种类-筛选项列表
     * 优惠卷管理-发行种类-筛选项列表
     */
    async userCouponsGrantKindGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserCouponOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/grant-kind`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserCouponOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 优惠卷管理-发行种类-筛选项列表
     * 优惠卷管理-发行种类-筛选项列表
     */
    async userCouponsGrantKindGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserCouponOptionRespVo> {
        const response = await this.userCouponsGrantKindGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * -----为客户端提供接口---- 优惠卷管理-发行类型-筛选项列表
     * 优惠卷管理-发行类型-筛选项列表
     */
    async userCouponsGrantTypeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserCouponOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/grant-type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserCouponOptionRespVoFromJSON(jsonValue));
    }

    /**
     * -----为客户端提供接口---- 优惠卷管理-发行类型-筛选项列表
     * 优惠卷管理-发行类型-筛选项列表
     */
    async userCouponsGrantTypeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserCouponOptionRespVo> {
        const response = await this.userCouponsGrantTypeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 删除优惠卷流水信息 删除优惠卷流水信息 指定优惠卷流水数据编号,删除优惠卷流水信息
     * 删除优惠卷流水信息
     */
    async userCouponsHistoryIdDeleteRaw(requestParameters: UserCouponsHistoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsHistoryIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 删除优惠卷流水信息 删除优惠卷流水信息 指定优惠卷流水数据编号,删除优惠卷流水信息
     * 删除优惠卷流水信息
     */
    async userCouponsHistoryIdDelete(requestParameters: UserCouponsHistoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsHistoryIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改优惠卷流水信息 修改优惠卷流水信息
     * 修改优惠卷流水信息
     */
    async userCouponsHistoryIdPutRaw(requestParameters: UserCouponsHistoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsHistoryIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCouponHistoryUpdateReqVoToJSON(requestParameters['userCouponHistoryUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改优惠卷流水信息 修改优惠卷流水信息
     * 修改优惠卷流水信息
     */
    async userCouponsHistoryIdPut(requestParameters: UserCouponsHistoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsHistoryIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取优惠卷流水信息列表(分页) 获取优惠卷流水信息列表(分页)
     * 获取优惠卷流水信息列表(分页)
     */
    async userCouponsHistoryListGetRaw(requestParameters: UserCouponsHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserCouponHistoryRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userCouponsHistoryListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userCouponsHistoryListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['userCouponId'] != null) {
            queryParameters['userCouponId'] = requestParameters['userCouponId'];
        }

        if (requestParameters['intOutType'] != null) {
            queryParameters['intOutType'] = requestParameters['intOutType'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/history/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserCouponHistoryRespVoFromJSON(jsonValue));
    }

    /**
     * 获取优惠卷流水信息列表(分页) 获取优惠卷流水信息列表(分页)
     * 获取优惠卷流水信息列表(分页)
     */
    async userCouponsHistoryListGet(requestParameters: UserCouponsHistoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserCouponHistoryRespVo> {
        const response = await this.userCouponsHistoryListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建优惠卷流水 创建优惠卷流水
     * 创建优惠卷流水
     */
    async userCouponsHistoryPostRaw(requestParameters: UserCouponsHistoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCouponHistoryCreateReqVoToJSON(requestParameters['userCouponHistoryCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建优惠卷流水 创建优惠卷流水
     * 创建优惠卷流水
     */
    async userCouponsHistoryPost(requestParameters: UserCouponsHistoryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsHistoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除用户优惠卷信息 删除用户优惠卷信息 指定优惠卷数据编号,删除用户优惠卷信息
     * 删除用户优惠卷信息
     */
    async userCouponsIdDeleteRaw(requestParameters: UserCouponsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 删除用户优惠卷信息 删除用户优惠卷信息 指定优惠卷数据编号,删除用户优惠卷信息
     * 删除用户优惠卷信息
     */
    async userCouponsIdDelete(requestParameters: UserCouponsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取用户优惠卷信息 获取优惠卷信息 指定优惠卷数据编号,获取优惠卷信息
     * 获取优惠卷信息
     */
    async userCouponsIdGetRaw(requestParameters: UserCouponsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserCouponInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserCouponInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 获取用户优惠卷信息 获取优惠卷信息 指定优惠卷数据编号,获取优惠卷信息
     * 获取优惠卷信息
     */
    async userCouponsIdGet(requestParameters: UserCouponsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserCouponInfoRespVo> {
        const response = await this.userCouponsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改用户优惠卷信息 修改用户优惠卷信息
     * 修改用户优惠卷信息
     */
    async userCouponsIdPutRaw(requestParameters: UserCouponsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userCouponsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCouponUpdateReqVoToJSON(requestParameters['userCouponUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改用户优惠卷信息 修改用户优惠卷信息
     * 修改用户优惠卷信息
     */
    async userCouponsIdPut(requestParameters: UserCouponsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 当前用户可用优惠券列表(分页)
     * 当前用户可用优惠券列表(分页)
     */
    async userCouponsListAvailableGetRaw(requestParameters: UserCouponsListAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetUserCouponAvailablePageRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userCouponsListAvailableGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userCouponsListAvailableGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['grantType'] != null) {
            queryParameters['grantType'] = requestParameters['grantType'];
        }

        if (requestParameters['additionalServiceIds'] != null) {
            queryParameters['additionalServiceIds'] = requestParameters['additionalServiceIds'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/list/available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetUserCouponAvailablePageRespVoFromJSON(jsonValue));
    }

    /**
     * 当前用户可用优惠券列表(分页)
     * 当前用户可用优惠券列表(分页)
     */
    async userCouponsListAvailableGet(requestParameters: UserCouponsListAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetUserCouponAvailablePageRespVo> {
        const response = await this.userCouponsListAvailableGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 查询用户优惠卷信息列表(分页) 查询用户优惠卷信息列表(分页)
     * 查询用户优惠卷信息列表(分页)
     */
    async userCouponsListGetRaw(requestParameters: UserCouponsListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserCouponInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userCouponsListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userCouponsListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['currencyCode'] != null) {
            queryParameters['currencyCode'] = requestParameters['currencyCode'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        if (requestParameters['canTrans'] != null) {
            queryParameters['canTrans'] = requestParameters['canTrans'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['grantType'] != null) {
            queryParameters['grantType'] = requestParameters['grantType'];
        }

        if (requestParameters['additionalServiceIds'] != null) {
            queryParameters['additionalServiceIds'] = requestParameters['additionalServiceIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserCouponInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 查询用户优惠卷信息列表(分页) 查询用户优惠卷信息列表(分页)
     * 查询用户优惠卷信息列表(分页)
     */
    async userCouponsListGet(requestParameters: UserCouponsListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserCouponInfoRespVo> {
        const response = await this.userCouponsListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·支付时可用优惠券列表
     * 客户端·支付时可用优惠券列表
     */
    async userCouponsListPayAvailableGetRaw(requestParameters: UserCouponsListPayAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserCouponPayAvailableRespVo>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling userCouponsListPayAvailableGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['billId'] != null) {
            queryParameters['billId'] = requestParameters['billId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/list/pay-available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserCouponPayAvailableRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端·支付时可用优惠券列表
     * 客户端·支付时可用优惠券列表
     */
    async userCouponsListPayAvailableGet(requestParameters: UserCouponsListPayAvailableGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserCouponPayAvailableRespVo> {
        const response = await this.userCouponsListPayAvailableGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取当前用户可用优惠卷列表(不分页)
     * 获取当前用户可用优惠卷列表(不分页)
     */
    async userCouponsListUsableGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetUserCouponAvailablePageRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/list/usable`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetUserCouponAvailablePageRespVoFromJSON(jsonValue));
    }

    /**
     * 获取当前用户可用优惠卷列表(不分页)
     * 获取当前用户可用优惠卷列表(不分页)
     */
    async userCouponsListUsableGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetUserCouponAvailablePageRespVo> {
        const response = await this.userCouponsListUsableGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 优惠卷使用记录俩列表(分页)
     * 优惠卷使用记录俩列表(分页)
     */
    async userCouponsListUsedGetRaw(requestParameters: UserCouponsListUsedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetUserCouponUsedPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling userCouponsListUsedGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userCouponsListUsedGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['grantType'] != null) {
            queryParameters['grantType'] = requestParameters['grantType'];
        }

        if (requestParameters['additionalServiceIds'] != null) {
            queryParameters['additionalServiceIds'] = requestParameters['additionalServiceIds'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons/list/used`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetUserCouponUsedPageListRespVoFromJSON(jsonValue));
    }

    /**
     * 优惠卷使用记录俩列表(分页)
     * 优惠卷使用记录俩列表(分页)
     */
    async userCouponsListUsedGet(requestParameters: UserCouponsListUsedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetUserCouponUsedPageListRespVo> {
        const response = await this.userCouponsListUsedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建优惠卷信息 创建优惠卷信息
     * 创建优惠卷信息
     */
    async userCouponsPostRaw(requestParameters: UserCouponsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-coupons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCouponCreateReqVoToJSON(requestParameters['userCouponCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建优惠卷信息 创建优惠卷信息
     * 创建优惠卷信息
     */
    async userCouponsPost(requestParameters: UserCouponsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userCouponsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
